<style>
    .goal-link {
        visibility: hidden;
    }
</style>

<template>
    <a class="goal-link" :href="url"><slot/></a>
</template>

<script>
import { goalReq } from "../js/utils.js";

export default {
    props: {
        printHyps: {
            type: Boolean,
            default: true
        }
    },
    
    data: function() {
        return {
            ascii: "",
            url: "",
            unicode: ""
        };
    },

    mounted: function() {
        this.ascii = this.$el.textContent;

        this.url = "/" + goalReq(this.ascii);

        this.unicode = engine.parseToUnicode({input: this.ascii, printHyps: this.printHyps});
        this.$el.innerHTML = this.unicode;
        $(this.$el).css("visibility", "visible");
    },
}
</script>